import React, { useState } from 'react';
import Swiper from 'react-id-swiper';
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  EffectCoverflow,
  Parallax,
  SwiperOptions,
} from 'swiper';
import { container } from 'tsyringe';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/a11y/a11y.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';
import 'swiper/components/effect-coverflow/effect-coverflow.scss';
import { importAll } from '@base/utils/helpers';
import { IPreferencesService } from '@base/features/preferences/model/types';
import styles from '../../styles/boardSelector.module.scss';
import { Preferences } from '@backgammon/constants/defaultPreferences';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, EffectCoverflow, Parallax]);

export default function BoardSelector() {
  const preferencesService: IPreferencesService<Preferences> = container.resolve('preferencesService');
  const [selectedBoard, setSelectedBoard] = useState(preferencesService.getPreferences('BOARD'));
  const thumbnails = importAll((require as any).context('./assets/thumbnails')).map((path) => ({
    path,
    name: path.split('.')[0],
  }));
  const swiperParams: SwiperOptions = {
    loop: true,
    speed: 800,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    effect: 'coverflow',
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 60,
      modifier: 1,
      slideShadows: true,
    },
    grabCursor: true,
    parallax: true,
    on: {
      slideChange: (swiper) => {
        setSelectedBoard(thumbnails[swiper.realIndex].name);
        preferencesService.updatePreferences('BOARD', thumbnails[swiper.realIndex].name);
      },
    },
    pagination: { el: '.swiper-pagination', type: 'bullets', clickable: true },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1000: { slidesPerView: 2, spaceBetween: 0 },
      767: { slidesPerView: 2, spaceBetween: -80 },
    },
    initialSlide: thumbnails.findIndex((el) => el.name === selectedBoard),
  };

  return (
    <div>
      <Swiper {...swiperParams}>
        {thumbnails.map((slide, index) => (
          <div style={{ backgroundImage: `url(${slide.path})` }} className={styles.slide} key={slide.name}>
            <div className={styles.boardName}>{thumbnails[index].name}</div>
          </div>
        ))}
      </Swiper>
    </div>
  );
}
